<template>
  <div id="contactus">
    <NavBar :mainPage="mainPage" />
    <section id="contact-intro" class="fullpage contact-intro" ref="contactstart">
      <Contactintro class="contact" :heading="heading" :paragraph="paragraphs.mapParagraph" />
    </section>
    <section id="contact-locations" class="fullpage mid">
      <Locations :locations="locations" />
    </section>
    <section id="contact-footer" class="fullpage" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer id="foot" />
    </section>
  </div>
</template>

<script>
import Contactintro from "./contact-intro";
import Locations from "./office-locations";

export default {
  name: "ContactUs",
  components: {
    Locations,
    Contactintro,
  },
  data() {
    return {
      mainPage: false,
      heading: "Contact Us",
      paragraphs: {
        mapParagraph:
          "ftcash is one of India's fastest growing financial technology venture, recognized by Forbes, which aims to empower micro-merchants and small businesses through financial inclusion using digital payments and loans.",
        downloadParagraph:
          "Let ftcash app help you to get loans without any collateral requirements to build the business of your dreams",
      },
      locations: {
        locationIcon: "location-marker.png",
        callIcon: "call-icon.png",
        locationName1: "Mumbai",
        locationAddress1:
          "A-405, 4th Floor, Boomerang Building, Yadav Nagar, Chandivali Farm Road, Chandivali. Andheri (East). Mumbai-400072",
        locationNumber1: "+91 983 349 6939",
        locationImage1: "mumbai-icon.png",
        locationName2: "Ahmedabad",
        locationAddress2:
          "Flexi Business Hub : 2nd floor, Madhur complex, Opp Gwalia Sweets, Near Stadium Six Road, Navrangpura, Ahmedabad-380009",
        locationNumber2: "+91 983 349 6939",
        locationImage2: "ahemdabad-icon.png",
        locationName3: "Hyderabad",
        locationAddress3:
          "Ftcash, H.No.:6-3-1111/15/B, 2 nd Floor, Nishat Bagh, Beside Lane of Keerti Lal Jewellers, Near Swapna Nursing Home, Somajiguda, Hyderabad – 500014",
        locationNumber3: "+91 983 349 6939",
        locationImage3: "hydrabad-icon.png",
        locationName4: "Pune",
        locationAddress4:
          "My Branch Services Private Limited. Amar Synergy, 2nd Floor, Unit No.201 & 202, , Sadhu Vaswani Chowk, Pune-411001",
        locationNumber4: "+91 983 349 6939",
        locationImage4: "pune-icon.png",
        locationName5: "Bangalore",
        locationAddress5:
          "Blooming Coworking Spaces, 3 rd floor, No 60/417, NKS Prime, below Rajaji Nagar Metro station, 20 th Main RD,1 st Block, Rajajinagar, Bengaluru Karnataka 560010",
        locationNumber5: "+91 983 349 6939",
        locationImage5: "Bangalore.png",
        locationName6: "Chennai",
        locationAddress6:
          "Srihari Enterprise ,No 4/14,West Avenue Road, Kodambakkam  Chennai 600 024.",
        locationNumber6: "+91 983 349 6939",
        locationImage6: "Chennai.png",
        locationName7: "Delhi",
        locationAddress7:
          "CO - Offiz ,B-1/632, 2 nd Floor, Janakpuri, Delhi-110058",
        locationNumber7: "+91 983 349 6939",
        locationImage7: "Delhi.png",
      },
    };
  },
  mounted() {
    
     this.$refs.contactstart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
     //window.scrollTo(0, 0);
  },
  metaInfo() {
    return{
    link: [
      { rel: 'canonical', href: 'https://www.ftcash.com/contact' },
    ],
    }
  },
};
</script>

<style scoped>
.contact-intro {
  background-image: url("../../assets/background/contact_form_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
   background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}

section#contact-intro {
    min-height: 100vh;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
  }

#left {
  transform: translate(10px, -48px);
}


@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .contact-intro {
    height: 100vh;
  }
  #left {
    transform: none;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  section#contact-intro {
    min-height: 65vh;
  }
  section#contact-locations {
    margin: 2rem 0;
    min-height: 65vh;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  section#contact-intro {
    min-height: 75vh;
  }
  #left {
    transform: none;
  }
}
@media (max-width: 480px) {
  
  .mid {
    padding: 10% 0;
  }
}
</style>
